import { createFileRoute } from '@tanstack/react-router';
import StaysPage from '../../components/webdesigned/StaysPage';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/stays')({
  component: () => (
    <WebDesignedPortal>
      <StaysPage />
    </WebDesignedPortal>
  ),
});
